import axios from "axios";

export default {
  getOrganisations() {
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE + "/EP/getOrganizations",
      null,
      { withCredentials: true }
    );
  },

  getBereiche(activeOrganisationId) {
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE + "/EP/getBereiche",
      {
        organization_id: activeOrganisationId,
      },
      { withCredentials: true }
    );
  },

  getTarifvertraege(activeBereichId) {
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE + "/EP/getTarifvertraege",
      {
        bereich_id: activeBereichId,
      },
      { withCredentials: true }
    );
  },

  getEmployeesForMonth(month) {
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE + "/EP/getEmployeesForMonth",
      {
        month: month,
      },
      { withCredentials: true }
    );
  },

  getServiceBucketsForEmployeeForMonth(month, employeeId) {
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE +
        "/EP/getServiceBucketsForEmployeeForMonth",
      {
        month: month,
        employee_id: employeeId,
      },
      { withCredentials: true }
    );
  },

  getTarifvertragForOffer(serviceId) {
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE + "/EP/getTarifvertragForOffer",
      {
        offer_id: serviceId,
      },
      { withCredentials: true }
    );
  },

  copyTarifvertrag(sourceTarifvertragId, validFrom, validTill) {
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE + "/EP/copyTarifvertrag",
      {
        source_tarifvertrag_id: sourceTarifvertragId,
        valid_from: validFrom,
        valid_till: validTill,
      },
      { withCredentials: true }
    );
  },

  updateEntgelt(entgeltId, value) {
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE + "/EP/updateEntgelt",
      {
        entgelt_id: entgeltId,
        value: value,
      },
      { withCredentials: true }
    );
  },

  publishTarifvertrag(tarifvertragId) {
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE + "/EP/publishTarifvertrag",
      {
        tarifvertrag_id: tarifvertragId,
      },
      { withCredentials: true }
    );
  },

  getFristen() {
    if (process.env.VUE_APP_ENV === "development") {
      return axios.get("./mock_fristen_response.json");
    }
    return axios.post(
      process.env.VUE_APP_BACKEND_BASE + "/EP/getFristen",
      null,
      { withCredentials: true }
    );
  },

  getLoggedInUser() {
    if (process.env.VUE_APP_ENV === "development") {
      return axios.get("./mock_user_response.json");
    }
    return axios.get(process.env.VUE_APP_BACKEND_BASE + "/users/iam", null, {
      withCredentials: true,
    });
  },
};
